import type { AgentId } from "@/config/agents";

export const ACTIVE_COMPANION_WORKFLOW_SLUGS = [
  "growth-copilot",
  "marcus-video-editor",
  "content-studio-copilot",
  "social-studio-copilot",
] as const;

export type ActiveCompanionWorkflowSlug = (typeof ACTIVE_COMPANION_WORKFLOW_SLUGS)[number];

const ACTIVE_COMPANION_WORKFLOW_SET = new Set<string>(ACTIVE_COMPANION_WORKFLOW_SLUGS);

const ACTIVE_COMPANION_AGENT_BY_WORKFLOW: Record<ActiveCompanionWorkflowSlug, AgentId> = {
  "growth-copilot": "operator",
  "marcus-video-editor": "operator",
  "content-studio-copilot": "nova",
  "social-studio-copilot": "saga",
};

export function isActiveCompanionWorkflow(
  workflowSlug: string | null | undefined,
): workflowSlug is ActiveCompanionWorkflowSlug {
  return typeof workflowSlug === "string" && ACTIVE_COMPANION_WORKFLOW_SET.has(workflowSlug);
}

export function resolveActiveCompanionAgentId(
  workflowSlug: string | null | undefined,
): AgentId | null {
  if (!isActiveCompanionWorkflow(workflowSlug)) return null;
  return ACTIVE_COMPANION_AGENT_BY_WORKFLOW[workflowSlug];
}
